export default {
  name: 'NaviBar',
  components: {},
  data () {
    return {
      logoMain: this.$store.state.imgPath + 'logoPSAIncheon.png',
      logoGlobal: this.$store.state.imgPath + 'logoPSAglobal.png'
    }
  },
  mounted () {
    this.updateSticked()
    window.addEventListener('scroll', this.updateSticked, { passive: true })
  },
  unmounted () {
    window.removeEventListener('scroll', this.updateSticked)
  },
  methods: {
    updateSticked () {
      const header = this.$el
      if (!header) return
      if (window.scrollY > 0) {
        header.classList.add('sticked')
      } else {
        header.classList.remove('sticked')
      }
    },
    changeKorean () {
      this.$i18n.locale = 'ko'
    },
    changeEnglish () {
      this.$i18n.locale = 'en'
    }
  }
}
